import { memo } from "react"
import styled from "styled-components"

const ConstrolSafe = styled.div`
  display: flex;
  padding: 0px;
  justify-content: center;
  align-items: center;
`

const IconArrowDown = () => {
  return (
    <ConstrolSafe>
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="16" viewBox="0 0 28 16" fill="none">
        <path
          d="M13.9998 15.1243C13.7012 15.1257 13.4146 15.0067 13.2048 14.7943L1.20477 2.79428C0.791732 2.35102 0.80392 1.66027 1.23234 1.23185C1.66076 0.803432 2.35151 0.791244 2.79477 1.20428L13.9998 12.4093L25.2048 1.20428C25.648 0.791244 26.3388 0.803432 26.7672 1.23185C27.1956 1.66027 27.2078 2.35102 26.7948 2.79428L14.7948 14.7943C14.5849 15.0067 14.2984 15.1257 13.9998 15.1243Z"
          fill="#333333"
        />
      </svg>
    </ConstrolSafe>
  )
}

export default memo(IconArrowDown)
